import { PageHero } from "@/components/site/PageHero";
import { Reveal, Overline } from "@/components/site/Reveal";
import { EnquiryForm } from "@/components/site/EnquiryForm";
import { company } from "@/data/content";
import { Phone, Mail, Clock, CheckCircle2 } from "lucide-react";

const assurances = [
  "Response within one working day",
  "Single point of contact",
  "No-obligation site survey",
  "Transparent, fixed pricing",
];

export default function Quote() {
  return (
    <div>
      <PageHero
        overline="Request a Quote"
        title={["Let's price up", "your facilities", "contract."]}
        subtitle="Tell us about your sites and the services you need. We'll come back with a tailored, no-obligation proposal built around your requirements."
      />

      <section className="bg-ink py-16 md:py-24 border-t border-border">
        <div className="max-w-container mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <Reveal><Overline>Why request a quote</Overline></Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-6 font-display font-bold text-3xl md:text-4xl tracking-tight text-white leading-[1.1]">
                A tailored proposal, not a generic price list.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <ul className="mt-8 space-y-4">
                {assurances.map((a) => (
                  <li key={a} className="flex items-center gap-3 text-white/90 text-lg">
                    <CheckCircle2 size={22} className="text-brand-light shrink-0" /> {a}
                  </li>
                ))}
              </ul>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-10 space-y-4 border-t border-border pt-8">
                <a href={`tel:${company.phone.replace(/\s/g, "")}`} className="flex items-center gap-3 text-white hover:text-brand-light transition-colors">
                  <Phone size={18} className="text-brand-light" /> {company.phone}
                </a>
                <a href={`mailto:${company.email}`} className="flex items-center gap-3 text-white hover:text-brand-light transition-colors">
                  <Mail size={18} className="text-brand-light" /> {company.email}
                </a>
                <div className="flex items-center gap-3 text-slatetxt">
                  <Clock size={18} className="text-brand-light" /> {company.coverage}
                </div>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <EnquiryForm type="quote" />
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
